import {
  get as getLocalStorage,
  remove as removeLocalStorage,
  set as setLocalStorage,
} from 'lib/storage/isomorphicLocalStorage'
import {
  get as getSessionStorage,
  set as setSessionStorage,
} from 'lib/storage/isomorphicSessionStorage'

const THERE_NO_PLACE_LIKE_HOME_POPUP_STORAGE_KEY = 'thereNoPlaceLikeHomePopupShown'
const THERE_NO_PLACE_LIKE_HOME_POPUP_SESSION_SNOOZE_KEY = 'thereNoPlaceLikeHomePopupSnoozed'

export function hasSeenThereNoPlaceLikeHomePopup() {
  return getLocalStorage(THERE_NO_PLACE_LIKE_HOME_POPUP_STORAGE_KEY) === true
}

export function markThereNoPlaceLikeHomePopupAsSeen() {
  setLocalStorage(THERE_NO_PLACE_LIKE_HOME_POPUP_STORAGE_KEY, true)
}

export function hasSnoozedThereNoPlaceLikeHomePopupForSession() {
  return getSessionStorage(THERE_NO_PLACE_LIKE_HOME_POPUP_SESSION_SNOOZE_KEY) === true
}

export function snoozeThereNoPlaceLikeHomePopupForSession() {
  removeLocalStorage(THERE_NO_PLACE_LIKE_HOME_POPUP_STORAGE_KEY)
  setSessionStorage(THERE_NO_PLACE_LIKE_HOME_POPUP_SESSION_SNOOZE_KEY, true)
}
